import ProductControl from './ProductControl';

export default ProductControl;
